import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  editOrganization,
  addUser,
  editRoleUser,
  deleteUser,
} from "../../api/organization";
import { ORGANIZATION_QUERY_KEY, ORGANIZATION_USERS_QUERY_KEY } from "../queries/useOrganization";

export function useEditOrganization() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: editOrganization,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ORGANIZATION_QUERY_KEY });
    },
  });
}

export function useAddUser() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ email }: { email: string }) => addUser(email),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ORGANIZATION_USERS_QUERY_KEY,
      });
    },
  });
}

export function useEditRoleUser() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ userId, roleSlug }: { userId: number; roleSlug: string }) =>
      editRoleUser(userId, roleSlug),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ORGANIZATION_USERS_QUERY_KEY,
      });
    },
  });
}

export function useDeleteUser() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ userId }: { userId: number }) => deleteUser(userId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ORGANIZATION_USERS_QUERY_KEY,
      });
    },
  });
}
